module.exports = import("https://www.gstatic.com/firebasejs/10.7.2/firebase-database.js");;